import React, { useEffect } from "react";
import { generatePath } from "react-router";
import { Route, Switch } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import { BreadcrumbsDynamic } from "stories/components";
import { PageHeader } from "components/Page"
import { PageContainer } from "components/Page"

import OptionsList from "views/app/OptionsList/OptionsList"
import PrivateStocksList from "views/app/PrivateStocksList/PrivateStocksList"

const Options = ({match, location, history}) => {
  
  const { t } = useTranslation();

  useEffect(() => {
    if (String(location?.pathname) === match.path) {
      history.push(generatePath(match.path + "/:tab", {
        tab: "options_list"
      }))
    }
  }, [match.path, location?.pathname, history])


  const getCrumbLinks = () => {
      const crumbLinks = [
        {name: t("web_options_frontpage","Etusivu"), url: "/dashboard/"},
        {name: t("routes_dashboard_derivatives", "Johdannaiset"), url: "/dashboard/options/options_list"},
      ]
  
      //if location state include crumbLinks return them
      if (location?.state && location?.state?.crumbLinks) {
        //made new const and deapcopy location.state.crumbLinks into it
        const crumbLinks = [...location.state.crumbLinks]
  
  
  
        crumbLinks.push({name:  t("routes_dashboard_derivatives", "Johdannaiset"), url: "/dashboard/options/options_list"})
        return crumbLinks
      }
      //else return default links
      return crumbLinks
  }


  return (
    <>
      <div className="row">
        <div className="col">
          <PageHeader title={t("routes_dashboard_derivatives", "Johdannaiset")} />
          <BreadcrumbsDynamic links={getCrumbLinks()} />
        </div>
      </div>
      
      <PageContainer>
        <Switch>
          <Route
            path={
              generatePath(match.path + "/:tab", {
                tab: "options_list"
              })
             
            }
            
            render={props => <OptionsList {...props} productId={match?.params?.productId} />}
          />
          <Route
          path={
            generatePath(match.path + "/:tab", {
              tab: "purchases"
            })
          }
          exact
          render={props => <PrivateStocksList {...props} productId={match?.params?.productId} />}
        />
        <Route
          path={
            generatePath(match.path + "/:tab", {
              tab: "example1"
            })
          }
          exact
          render={props => <PrivateStocksList {...props} productId={match?.params?.productId} />}
        />
        </Switch>
      </PageContainer>
      
    </>
  );
}

export default Options;
